"use client";

import Script from "next/script";

const MapsScript = () => {
  if (!process.env.NEXT_PUBLIC_MAPS_API_KEY) {
    return null;
  }

  return (
    <Script
      src={`https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_MAPS_API_KEY}&libraries=places&loading=async`}
      strategy="lazyOnload"
    ></Script>
  );
};

export default MapsScript;
